import { FieldHookConfig, useField } from "formik";

interface CheckboxFieldProps {
    label: string;
    description?: string;
}

export default function CheckboxField({ label, description, ...props }: CheckboxFieldProps & FieldHookConfig<boolean>) {
    const [field, meta] = useField({ name: props.name, type: 'checkbox' });

    return (
        <div>
            <div className='flex items-start'>
                <div className='flex items-center h-5'>
                    <input
                        type='checkbox'
                        className='focus:ring-loving-500 h-4 w-4 text-loving-600 border-gray-300 rounded'
                        {...field}
                        />
                </div>
                <div className='ml-3 text-sm'>
                    <label htmlFor='post_anon' className='font-medium text-gray-700'>{label}</label>
                    {description && <p className='text-gray-500'>Your name won&apos;t be shown on the post</p>}
                </div>
            </div>
        </div>
    )
}